import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" fill="none" viewBox="0 0 15 19">
      <path
        fill={props.fill || '#1D252D'}
        d="M.368 12.41v1.648a3.1 3.1 0 001.566 2.707l1.96 1.1c.756.406 1.573.62 2.395.62h3.787c2.715 0 4.924-2.267 4.924-5.054v-3.229c0-1.401-1.095-2.547-2.458-2.596a2.547 2.547 0 00-1.992-.984h-.475c-.125 0-.25.01-.373.029a2.493 2.493 0 00-1.528-.52h-.475V3.042C7.699 1.65 6.565.515 5.203.515c-1.424 0-2.589 1.134-2.589 2.527v5.956l-1.111.997c-.701.61-1.135 1.478-1.135 2.415zm1.684 0c0-.432.186-.835.51-1.102l.614-.55v1.55c0 .309.284.561.561.561a.584.584 0 00.562-.561V3.042c0-.464.378-.842.81-.842.464 0 .843.378.843.842v4.984c0 .336.279.563.567.563a.559.559 0 00.517-.357c.078-.038.253-.417.632-.417h.475c.736 0 .629.688 1.203.688.288 0 .345-.196.697-.196h.475c.897 0 .642.99 1.357.99h.017l.56-.008c.477 0 .864.41.864.913v3.229c0 1.858-1.453 3.37-3.24 3.37H6.29a3.16 3.16 0 01-1.54-.405l-1.958-1.1a1.413 1.413 0 01-.707-1.238V12.41h-.032z"
      ></path>
    </svg>
  );
}

export default Icon;
